<template>
    <div v-resize="OnResize">
        <v-container fluid class="bg-white custom-responsive-padding pt-4 pb-1" ref="divOne">
            <!--- mobile and ipad---------->
            <v-row v-if="isIpadOrMobile && searchResults.page.length">
                <v-col cols="12" class="py-0 d-none d-sm-block d-md-block my-0">
                    <div v-if="categoryListIdWise">
                        <BreadcrumbComponent
                            :breadcrumbVal="breadcrumbData"
                            :key="breadcrumbData"
                        />
                    </div>
                </v-col>

                <v-col
                    v-if="enabledFilters && enabledFilters.length >= 2"
                    class="pt-3 pt-sm-3"
                    cols="12"
                    sm="12"
                >
                    <ul class="pl-0" v-for="(value, index) in enabledFilters" :key="index">
                        <li class="d-flex pb-1" v-if="value.label != 'Category'">
                            <div>
                                <b>
                                    <span class="text-uppercase">{{ value.label }}</span>
                                </b>
                                : {{ value.value }}
                            </div>
                            <v-hover v-slot:default="{ isHovering }">
                                <v-icon
                                    :icon="mdiClose"
                                    :color="isHovering ? 'primary' : ''"
                                    @click.stop="deleteFilter(value, index)"
                                    class="searchproducts-cancel-buttons cursor-pointer transparent-background ml-4"
                                />
                            </v-hover>
                        </li>
                    </ul>
                </v-col>

                <v-col cols="4" class="d-lg-none">
                    <v-menu
                        allow-overflow
                        location="bottom"
                        :close-on-content-click="closeFilterMenu"
                        v-model="menu"
                    >
                        <template v-slot:activator="{ props }">
                            <v-btn
                                color="primary"
                                v-bind="props"
                                variant="outlined"
                                @click="setFilterValue"
                                block
                                class="word-break fontsize-16 line-height-21 ls-n009 font-weight-400 categorybaseproducts-sortby-button select-change-icon regular-font"
                                rounded="0"
                                size="large"
                                :height="sortByCriteriaHeight"
                            >
                                FILTER
                            </v-btn>
                        </template>

                        <v-list block>
                            <v-list-item>
                                <v-list-item-title class="filter-component-width">
                                    <v-row>
                                        <v-col cols="12">
                                            <v-btn
                                                color="primary"
                                                class="text-uppercase ls-0 body productpage-button"
                                                variant="outlined"
                                                rounded="0"
                                                block
                                                @click="clearFilter()"
                                                >CLEAR</v-btn
                                            >
                                        </v-col>
                                    </v-row>
                                    <FilterComponent
                                        @clearAction="actionClear"
                                        :filterList="availalableFilters"
                                        :inProgress="inProgress"
                                        :enabledFilters="enabledFilters"
                                        @applyNewFilter="applyFilter"
                                        :key="availalableFilters"
                                    ></FilterComponent>
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-col>

                <v-col cols="8" lg="2" md="4" sm="4">
                    <v-select
                        :items="sortCriteria"
                        class="word-break fontsize-16 line-height-21 ls-n009 font-weight-400 categorybaseproducts-sortby-button categorybaseproducts-sortby-button-mobile select-change-icon regular-font"
                        dense
                        flat
                        attach
                        solo
                        ref="sortByCriteria"
                        item-title="label"
                        item-value="value"
                        background-color="transparent"
                        v-model="sortBy"
                        :menu-icon="mdiChevronDown"
                        density="compact"
                        variant="outlined"
                        @update:modelValue="sortAndNextPage()"
                        hide-details
                    ></v-select>
                </v-col>
                <v-col md="12" sm="12" cols="12" class="py-0" v-if="searchPageContent">
                    <p class="h3 regular-font mb-4">Search results for : '{{ keywords }}'</p>
                </v-col>
            </v-row>
            <!------------end  mobile and ipad --->

            <v-row class="mx-0">
                <v-row align="center" class="pt-1" v-if="!isIpadOrMobile">
                    <v-col lg="7" md="8" sm="7" cols="7" class="py-0" v-if="searchPageContent">
                        <p class="h3 regular-font mb-1 mt-10">
                            Search results for : '{{ keywords }}'
                        </p>
                    </v-col>
                    <div class="d-none w-100 d-sm-flex align-center">
                        <v-col lg="8" md="8" sm="8" cols="8" class="py-0" v-if="categoryListIdWise">
                            <BreadcrumbComponent
                                :breadcrumbVal="breadcrumbData"
                                :key="breadcrumbData"
                            />
                        </v-col>
                        <v-col
                            lg="auto"
                            md="auto"
                            sm="auto"
                            cols="auto"
                            class="py-0 ml-auto"
                            v-if="categoryListIdWise && searchResultsNew?.page?.length"
                        >
                            <span
                                class="text-uppercase primary--text my-3 fontsize-16 line-height-21 float-right ls-n009 font-weight-400 regular-font"
                            >
                                Sort by:
                            </span>
                        </v-col>

                        <v-col
                            lg="auto"
                            md="auto"
                            sm="auto"
                            cols="auto"
                            class="pb-0 pt-6 pr-4"
                            v-if="searchResultsNew?.page?.length"
                        >
                            <v-select
                                :items="criteria"
                                class="fontsize-16 ls-n009 font-weight-400 categorybaseproducts-sortby-button categorybaseproducts-select-button select-change-icon regular-font categorybaseproducts-select-button-width"
                                attach
                                flat
                                solo
                                ref="sortAndNextPage"
                                v-model="sortBy"
                                item-title="label"
                                item-value="value"
                                background-color="transparent"
                                :menu-icon="mdiPlus"
                                density="compact"
                                variant="outlined"
                                @update:modelValue="sortAndNextPage()"
                            ></v-select>
                        </v-col>
                    </div>
                </v-row>
            </v-row>
            <v-row class="d-none d-sm-flex mx-0" v-if="!isIpadOrMobile">
                <v-col class="px-1 py-0 pr-md-12" cols="12" lg="3" md="4" sm="4">
                    <ul class="pl-0" v-for="(value, index) in enabledFilters" :key="index">
                        <li
                            class="d-flex justify-space-between pb-1"
                            v-if="value.label != 'Category'"
                        >
                            <div>
                                <b>
                                    <span class="text-uppercase">{{ value.label }}</span>
                                </b>
                                : {{ value.value }}
                            </div>
                            <v-hover v-slot:default="{ isHovering }">
                                <v-icon
                                    :icon="mdiClose"
                                    :color="isHovering ? 'primary' : ''"
                                    @click.stop="deleteFilter(value, index)"
                                    class="categorybaseproduct-cancel-buttons cursor-pointer"
                                />
                            </v-hover>
                        </li>
                    </ul>
                </v-col>
            </v-row>
            <v-row class="mx-sm-0">
                <v-col
                    v-if="!inProgress && searchResultsNew?.page?.length > 0"
                    lg="2"
                    class="d-none d-lg-block pt-0 pl-0"
                >
                    <v-row justify="center" class="pt-6 mx-0 ml-n2">
                        <FilterComponent
                            :filterList="availalableFilters"
                            :inProgress="inProgress"
                            :enabledFilters="enabledFilters"
                            @applyNewFilter="applyFilter"
                            :key="availalableFilters"
                        />
                    </v-row>
                </v-col>
                <v-col
                    cols="12"
                    :lg="inProgress || !searchResultsNew?.page?.length ? 12 : 10"
                    md="12"
                    sm="12"
                    class="pt-0 px-sm-0 pr-lg-4"
                    ref="divOnesecond"
                >
                    <v-row v-if="inProgress" class="skeleton-grid ma-0">
                        <!-- Left Sidebar Filter Skeleton (only on lg and up) -->
                        <v-col
                            v-if="$vuetify.display.lgAndUp"
                            lg="2"
                            class="d-none d-lg-block pa-0 pr-8"
                        >
                            <div class="pt-8">
                                <!-- 4 Filter Sections (Color, Size, Price, etc.) -->
                                <div
                                    v-for="section in 4"
                                    :key="'filter-section-' + section"
                                    class="mb-10"
                                >
                                    <v-skeleton-loader
                                        type="list-item"
                                        class="mb-4 skeleton-filter-title"
                                    />
                                    <div v-for="item in 6" :key="'filter-item-' + item">
                                        <v-skeleton-loader
                                            type="list-item-two-line"
                                            class="mb-3"
                                            height="36"
                                        />
                                    </div>
                                </div>
                            </div>
                        </v-col>

                        <!-- Right Side Product Grid Skeleton -->
                        <v-col cols="12" :lg="$vuetify.display.lgAndUp ? 10 : 12" class="pa-0">
                            <v-row class="ma-0">
                                <!-- 9 Product Cards (3 per row on desktop) -->
                                <v-col
                                    v-for="i in 9"
                                    :key="i"
                                    cols="12"
                                    sm="6"
                                    md="4"
                                    lg="4"
                                    class="pa-4 pa-sm-6 pa-md-8"
                                >
                                    <v-skeleton-loader
                                        type="card"
                                        height="300"
                                        class="rounded-lg skeleton-product-card"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <template v-else>
                        <v-row v-if="searchResultsNew?.page?.length" class="mt-0">
                            <v-col
                                v-for="(product, index) in searchResultsNew.page"
                                :key="product.i || index"
                                lg="4"
                                md="4"
                                sm="4"
                                cols="12"
                                class="pr-lg-0 cursor-pointer pt-lg-6 mb-0 pb-0"
                            >
                                <div class="product-image-wrapper">
                                    <div
                                        v-if="!loadedImages[product.i]"
                                        class="skeleton-placeholder"
                                    ></div>
                                    <picture v-show="loadedImages[product.i]">
                                        <source
                                            :media="`(min-width:100px)`"
                                            :srcset="
                                                getProductImageUrl(product.i, {
                                                    width: 360,
                                                    height: 360,
                                                })
                                            "
                                            style="width: 100%"
                                        />
                                        <img
                                            @click="gotoProductDetails(product.n, product)"
                                            :src="
                                                getProductImageUrl(product.i, {
                                                    width: 1366,
                                                    height: 1366,
                                                })
                                            "
                                            style="width: 100%"
                                            :alt="product.n"
                                            :title="product.n"
                                            onerror="
                                                this.onerror = null
                                                this.parentNode.children[0].srcset =
                                                    'https://cdn.crane.com/images/default_crane_image.webp'
                                            "
                                            @load="imageLoaded(product.i)"
                                            @error="imageLoaded(product.i)"
                                        />
                                    </picture>
                                </div>

                                <v-row
                                    v-if="product.t == 'configurable' && product.cpo"
                                    class="mt-1"
                                >
                                    <v-col cols="12" class="pb-0">
                                        <span
                                            v-if="
                                                configurableProductOptionsCheck(
                                                    product.cpo,
                                                    'choose_color'
                                                )
                                            "
                                        >
                                            <div
                                                v-for="(color, i) in product.cpd"
                                                :key="i"
                                                class="d-inline-block"
                                            >
                                                <v-tooltip location="bottom">
                                                    <template v-slot:activator="{ props }">
                                                        <div
                                                            v-bind="props"
                                                            v-on="on"
                                                            class="search-color-circle d-flex justify-center align-center cursor-pointer"
                                                            v-bind:class="{
                                                                'search-color-circle-border':
                                                                    color.letter_label ==
                                                                    searchResultsNew.page[index].sc,
                                                            }"
                                                        >
                                                            <div
                                                                class="search-product-color-circle cursor-pointer"
                                                                :style="
                                                                    'background-color:' +
                                                                    setHexaColor(color.letter_label)
                                                                "
                                                                @click="setColor(color, index)"
                                                            ></div>
                                                        </div>
                                                    </template>
                                                    <span>{{ color.letter_label }}</span>
                                                </v-tooltip>
                                            </div>
                                        </span>
                                    </v-col>
                                </v-row>
                                <v-row class="py-0 mt-2 mb-0">
                                    <v-col cols="7" class="pb-0">
                                        <h1
                                            class="float-left fontsize-14 body ls-n009 fontcolor-black-darken font-weight-300"
                                        >
                                            {{ product.n }}
                                        </h1>
                                    </v-col>

                                    <v-col cols="5" class="pb-0" v-if="product.t != 'configurable'">
                                        <p
                                            v-if="product.bv == '2.1' || product.bv == '2.0'"
                                            class="float-right fontsize-14 body ls-n009 fontcolor-black-darken font-weight-300"
                                        >
                                            <span> From ${{ priceFormatter(product.p) }} </span>
                                        </p>
                                        <div
                                            v-else
                                            class="float-right fontsize-14 body ls-n009 fontcolor-black-darken font-weight-300"
                                        >
                                            <div v-if="product.sp">
                                                <s>${{ product.p }}</s> &nbsp;
                                                <p class="text-red mb-0">
                                                    ${{ roundUp(product.sp) }}
                                                </p>
                                                / {{ product.u }}
                                            </div>
                                            <div v-else-if="product.p != 0">
                                                <p>
                                                    ${{ priceFormatter(product.p) }}
                                                    /
                                                    {{ product.u }}
                                                </p>
                                            </div>
                                            <div v-else>
                                                <p>TBD</p>
                                            </div>
                                        </div>
                                    </v-col>
                                    <v-col cols="5" class="pb-0" v-if="product.t == 'configurable'">
                                        <p
                                            v-if="product.cpr"
                                            class="float-right fontsize-14 body ls-n009 fontcolor-black-darken font-weight-300"
                                        >
                                            {{ product.cpr }}
                                        </p>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row v-else class="ma-0">
                            <v-col cols="12" class="py-12 text-center">
                                <v-alert
                                    type="error"
                                    density="comfortable"
                                    variant="tonal"
                                    class="font-weight-300 body-font h3 mx-auto"
                                >
                                    {{ noProducts }}
                                </v-alert>
                            </v-col>
                        </v-row>
                    </template>
                    <v-row
                        class="pr-5 pt-10 pb-0 ma-0"
                        align="center"
                        justify="end"
                        v-if="!inProgress && searchResultsNew?.page?.length"
                    >
                        <v-col cols="12" sm="6" md="8" lg="8" class="pa-0">
                            <v-col
                                cols="12"
                                sm="6"
                                md="8"
                                lg="8"
                                class="pa-0 custom-pagination d-flex flex-column"
                            >
                                <v-pagination
                                    v-if="pageSize != 'ALL'"
                                    class="categorybaseproducts-pagination-button d-flex justify-flex-start ma-auto"
                                    v-model="pageNumber"
                                    :length="totalVisiblePages"
                                    :total-visible="5"
                                    elevation="0"
                                    @update:modelValue="pageViewChange()"
                                    rounded="circle"
                                    size="small"
                                >
                                    <template #prev>
                                        <v-col v-if="pageNumber > 1" class="pa-1"
                                            ><span
                                                class="cursor-pointer text-body-2 font-weight-regular text-uppercase line-height-18 px-0 mr-n5"
                                                @click="prev"
                                                >Previous</span
                                            ></v-col
                                        >
                                    </template>
                                    <template #next>
                                        <v-col v-if="pageNumber !== totalVisiblePages" class="pa-1"
                                            ><span
                                                class="cursor-pointer text-body-2 font-weight-regular text-uppercase line-height-18 px-0 ml-n2"
                                                @click="next"
                                                >Next</span
                                            ></v-col
                                        >
                                    </template>
                                </v-pagination>
                            </v-col>
                        </v-col>
                        <v-col sm="6" md="4" lg="4" class="d-none d-sm-block">
                            <v-row align="center" justify="end">
                                <p
                                    class="mr-2 text-uppercase fontsize-14 ls-n01 font-weight-400 fontcolor-black-darken"
                                >
                                    Show:
                                </p>
                                <v-select
                                    class="fontsize-16 body ls-n01 transparent-background fontcolor-black-darken categorybaseproducts-overflow-button"
                                    :items="pageNum"
                                    v-model="pageSize"
                                    item-value="text"
                                    item-title="text"
                                    target="#dropdown-example"
                                    :hide-no-data="true"
                                    no-data-text
                                    density="compact"
                                    variant="outlined"
                                    @update:modelValue="pageSizeWiseProduct()"
                                ></v-select>
                                <p
                                    class="ml-2 text-uppercase fontsize-14 ls-n01 font-weight-400 fontcolor-grey-shade8b"
                                >
                                    Per Page
                                </p>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import { mdiPlus, mdiClose, mdiChevronDown } from '@mdi/js'
// import * as easings from "vuetify/lib/services/goto/easing-patterns";
import BreadcrumbComponent from '@/components/crane/breadcrumb/Breadcrumb.vue'
import { createHelpers } from 'vuex-map-fields'
import { mapState } from 'vuex'
import CategoryHeroContent from '@/components/crane/category/CategoryHeroContent.vue'
import FilterComponent from '@/components/crane/filter/FilterComponent.vue'
const cloudeflareBaseImageUrl = import.meta.env.VITE_APP_CLOUDFLARE_IMAGES_URL
const mediaImageUrl = import.meta.env.VITE_APP_ECOMMERCE_MEDIA_URL
import {
    googleAanalyticsEventCategoryPage,
    googleAanalyticsEventSelectContent,
    colorsName,
    priceFormatter,
} from '@/services/util.service'
const { mapFields } = createHelpers({
    getterType: 'catalogBrowser/getField',
    mutationType: 'catalogBrowser/updateField',
})
export default {
    name: 'SearchProductsComponent',
    components: {
        FilterComponent,
        BreadcrumbComponent,
    },
    props: ['criteria', 'searchPageContent', 'breadcrumbData', 'categoryPageContent'],

    computed: {
        ...mapState({
            searchResults: (state) => state.catalogBrowser.searchResults,
            enabledFilters: (state) => state.catalogBrowser.enabledFilters,
            searchTerms: (state) => state.catalogBrowser.searchTerms,
            inProgress: (state) => state.catalogBrowser.inProgress,
            totalProducts: (state) => state.catalogBrowser.totalItems,
            availalableFilters: (state) => state.catalogBrowser.availalableFilters,
            builderioLoadCheckFlag: (state) => state.catalogBrowser.builderioLoadCheckFlag,
            categoryProductLoadFlag: (state) => state.catalogBrowser.categoryProductLoadFlag,
        }),
        ...mapFields([
            'searchTerms',
            'searchTerms.pageNumber',
            'searchTerms.pageSize',
            'searchTerms.keywords',
            'searchTerms.sortBy',
            'searchTerms.filters',
        ]),
        easingOptions() {
            return {
                duration: this.duration,
                easing: this.easing,
            }
        },
        categoryListIdWise: function () {
            return this.$store.state.headerCategoryList.categoryListIdWise
        },
        lazyLoadImagePathUrl() {
            return import.meta.env.VITE_LAZY_SRC_URL
        },

        imageBaseParams() {
            return import.meta.env.VITE_IMAGE_CATEGORY_PARAMS
        },
        isIpadOrMobile: function () {
            return this.$vuetify.display.mdAndDown ? true : false
        },
        isIpad: function () {
            return this.$vuetify.display.smOnly || this.$vuetify.display.mdOnly ? true : false
        },
        isMobile: function () {
            return this.$vuetify.display.xs ? true : false
        },
        categoryId: function () {
            return this.$route.meta.id
        },
        newUser() {
            if (this.$vuetify.display.smAndDown) return false
            let userVisits = this.$store.state.layout.user.userVisits
            if (userVisits && Number(userVisits) > 1) return false
            else return true
        },
        sortCriteria() {
            return this.criteria.map((c) => ({
                ...c,
                label: `SORT: ${c.label}`,
            }))
        },
    },
    watch: {
        totalProducts() {
            if (this.pageSize != 'ALL') {
                this.totalVisiblePages = Math.ceil(this.totalProducts / Number(this.pageSize))
            }
        },
        searchResults: {
            handler: function () {
                this.searchResultsNew = JSON.parse(JSON.stringify(this.searchResults))
            },
            deep: true,
        },
        keywords() {
            googleAanalyticsEventCategoryPage(
                this.searchResults.page,
                this.categoryId,
                this.categoryListIdWise
            )
        },
        categoryId() {
            googleAanalyticsEventCategoryPage(
                this.searchResults.page,
                this.categoryId,
                this.categoryListIdWise
            )
        },
        pageSize() {
            if (this.pageSize != 'ALL' && this.totalProducts) {
                this.totalVisiblePages = Math.ceil(this.totalProducts / Number(this.pageSize))
            }
        },
    },
    data: () => ({
        mdiPlus,
        mdiClose,
        mdiChevronDown,
        mediaImageUrl,
        cloudeflareBaseImageUrl,
        priceFormatter: priceFormatter,
        searchResultsNew: '',
        selectedColor: [],
        closeFilterMenu: false,
        checkClear: false,
        easing: 'easeInOutCubic',
        // easings: Object.keys(easings),
        duration: 100,
        totalVisiblePages: 0,
        menu: false,
        showDrawarFilter: false,
        pageNum: [
            { text: 9, callback: () => 9 },
            { text: 18, callback: () => 18 },
            { text: 27, callback: () => 27 },
            { text: 'ALL', callback: () => 'ALL' },
        ],
        noProducts: 'No products found.',
        hideHeroContent: true,
        sortByCriteriaHeight: 46,
        loadedImages: {},
    }),
    methods: {
        imageLoaded(productId) {
            this.loadedImages[productId] = true
        },
        replacePriceString(str) {
            let val = str.replace('price:"', '')
            val = val.replace('"}', '')
            return val
        },
        fetchProductImageName(imageFullName) {
            if (imageFullName) {
                let fileExtention = imageFullName.split('/')
                let filename = fileExtention[fileExtention.length - 1].split('.')[0]
                return filename
            } else {
                return ''
            }
        },
        getProductImageUrl(imagePath, options = {}) {
            if (!imagePath) return ''

            const { width, height, format = 'auto' } = options

            const params = []

            if (width) params.push(`width=${width}`)
            if (height) params.push(`height=${height}`)

            if (format) params.push(`format=${format}`)

            const paramString = params.join(',')

            return `${cloudeflareBaseImageUrl}/${paramString}/${mediaImageUrl}/media/catalog/product${imagePath}`
        },
        setHexaColor(colorVal) {
            let hexaColor = colorsName.find((obj) => obj.name == colorVal)
            if (hexaColor) {
                return hexaColor.colorHex
            } else {
                return '#fffffff'
            }
        },
        setColor(color, index) {
            this.searchResultsNew.page[index].sc = color.letter_label
            if (color && color.file) {
                this.searchResultsNew.page[index].i = color.file
            }
        },
        configurableProductOptionsCheck(configurableProductOptions, lable) {
            if (configurableProductOptions && configurableProductOptions.length) {
                let result = configurableProductOptions.filter((element) => {
                    return element.l === lable
                })

                if (result && result.length > 0) {
                    return true
                } else {
                    return false
                }
            } else {
                return false
            }
        },
        prev() {
            if (this.pageNumber !== 1) {
                this.pageNumber = this.pageNumber - 1
                this.pageViewChange()
            }
        },
        next() {
            if (this.pageNumber !== this.totalVisiblePages) {
                this.pageNumber = this.pageNumber + 1
                this.pageViewChange()
            }
        },
        async clearFilter() {
            await this.$store.dispatch('catalogBrowser/clearFilter')
            this.closeFilterMenu = true
            this.pageNumber = 1
            this.$emit('criteriaChanged')
        },
        async deleteFilter(value, index) {
            await this.$store.dispatch('catalogBrowser/deleteSelectedFilter', {
                index: index,
            })
            this.pageNumber = 1
            this.$emit('criteriaChanged')
            googleAanalyticsEventCategoryPage(
                this.searchResults.page,
                this.categoryId,
                this.categoryListIdWise
            )
        },

        setFilterValue() {
            this.closeFilterMenu = false
        },
        async applyFilter(filterObj) {
            await this.$store.dispatch('catalogBrowser/setNewFilter', filterObj)
            this.closeFilterMenu = true
            this.pageNumber = 1
            this.$emit('criteriaChanged')
            googleAanalyticsEventCategoryPage(
                this.searchResults.page,
                this.categoryId,
                this.categoryListIdWise
            )
        },
        async actionClear() {
            await this.$store.dispatch('catalogBrowser/clearFilter')
            this.closeFilterMenu = true
        },
        OnResize() {
            this.sortByCriteriaHeight = this.$refs.sortByCriteria
                ? this.$refs.sortByCriteria.$el.clientHeight
                : 46
            setTimeout(() => {
                if (this.$vuetify.display.lgAndUp) {
                    this.showDrawarFilter = false
                }
            }, 200)
        },
        gotoProductDetails(productName, product) {
            googleAanalyticsEventSelectContent('select_content', product, this.categoryId)
            this.$router.push({
                name: productName,
                query: {
                    categoryId: this.categoryId,
                },
            })
        },
        scrollToTop() {
            const data = this.$refs.divOne
            if (data && data.$el) {
                this.$smoothScroll({
                    scrollTo: data.$el.scrollTop,
                    duration: 300,
                    easingFunction: 'easeInOutCubic',
                    updateHistory: false,
                })
            }
        },
        pageViewChange() {
            this.$emit('criteriaChanged')
            googleAanalyticsEventCategoryPage(
                this.searchResults.page,
                this.categoryId,
                this.categoryListIdWise
            )
            this.scrollToTop()
        },
        pageSizeWiseProduct() {
            this.updatePageNumber()
            this.$emit('criteriaChanged')
            googleAanalyticsEventCategoryPage(
                this.searchResults.page,
                this.categoryId,
                this.categoryListIdWise
            )
            this.scrollToTop()
        },
        sortAndNextPage() {
            this.$emit('criteriaChanged')
            googleAanalyticsEventCategoryPage(
                this.searchResults.page,
                this.categoryId,
                this.categoryListIdWise
            )
        },

        updatePageNumber() {
            if (this.pageNumber * Number(this.pageSize) > this.totalProducts) {
                let quotient = Math.floor(this.totalProducts / Number(this.pageSize))
                let remainder = this.totalProducts % Number(this.pageSize)
                this.pageNumber = quotient + (remainder == 0 ? 0 : 1)
            } else {
            }
        },
        roundUp(num) {
            var with2Decimals = num.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
            return with2Decimals
        },
    },
    created() {
        this.searchResultsNew = JSON.parse(JSON.stringify(this.searchResults))
        if (this.searchTerms) {
            googleAanalyticsEventCategoryPage(
                this.searchResults.page,
                this.categoryId,
                this.categoryListIdWise
            )
        }
        if (this.totalProducts)
            this.totalVisiblePages = Math.ceil(this.totalProducts / Number(this.pageSize))
    },
}
</script>
<style lang="scss">
.sort-button.theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
    background: transparent !important;
}
.categorybaseproducts-pagination-button .v-pagination__item--is-active .v-btn {
    outline: #ffffff !important;
    color: #fff;
    background-color: #3d5789;
    opacity: 1;
}
.categorybaseproducts-pagination-button .v-pagination__item {
    outline: #ffffff !important;
    box-shadow: none !important;
    padding: 0px !important;
    margin: 0px !important;
}
.categorybaseproducts-pagination-button,
.categorybaseproducts-pagination-button .v-pagination__list {
    justify-content: flex-start;
}
.categorybaseproducts-overflow-button .v-input__control {
    border-left: 1px solid #dcdddd;
    border-right: 1px solid #dcdddd;
    max-width: 85px;
    max-height: 36px;
}
.categorybaseproducts-overflow-button .v-input__control {
    border-top: 2px solid #dcdddd;
    border-bottom: 2px solid #dcdddd;
}
.categorybaseproducts-overflow-button {
    max-width: 85px;
}
.categorybaseproducts-overflow-button .v-field__input,
.categorybaseproducts-overflow-button .v-field__append-inner {
    padding-top: 5px;
}

.categorybaseproducts-overflow-button .v-field__outline {
    display: none;
}
.categorybaseproducts-pagination-button
    .v-pagination__navigation.v-pagination__navigation--disabled {
    display: none;
}
.categorybaseproducts-pagination-button .v-pagination__navigation .v-icon.v-icon {
    font-style: normal !important;
    color: #1d1d1d !important;
    text-transform: uppercase !important;
    font-size: 14px;
    font-family: 'Whyte-Regular', sans-serif;
    letter-spacing: -0.1px;
}
.categorybaseproducts-select-button .v-input__control .v-input__slot {
    border: thin solid #8b8b8b !important;
}
.categorybaseproducts-select-button:hover .v-input__control .v-input__slot {
    border: thin solid #3d5789 !important;
}
.categorybaseproducts-select-button.v-input--is-label-active.v-input--is-focused
    .v-input__control
    .v-input__slot {
    border: thin solid #3d5789 !important;
    width: 500px !important;
}
.categorybaseproducts-select-button:hover .v-select__selection.v-select__selection--comma {
    color: #3d5789 !important;
}
.categorybaseproducts-select-button:hover .v-input__append-inner .v-input__icon .v-icon {
    color: #3d5789 !important;
}
.categorybaseproducts-pagination-button .v-pagination__navigation {
    outline: #ffffff !important;
    box-shadow: none !important;
    padding: 0px !important;
}
.custom-pagination li:nth-child(1) {
    margin-right: 15px !important;
    margin-left: 15px;
}
.categorybaseproducts-select-button.v-input--is-label-active.v-input--is-focused
    .v-select__selection.v-select__selection--comma {
    color: #3d5789 !important;
}
.categorybaseproducts-sortby-button .v-select__selection .v-select__selection-text,
.categorybaseproducts-filter-button .v-select__selection .v-select__selection-text {
    color: #3d5789 !important;
}
.categorybaseproducts-sortby-button .v-field__outline,
.categorybaseproducts-filter-button .v-field__outline {
    display: none;
}
.categorybaseproducts-sortby-button .v-text-field__details,
.categorybaseproducts-filter-button .v-text-field__details {
    display: none;
}
.categorybaseproducts-sortby-button .v-input__control,
.categorybaseproducts-filter-button .v-input__control {
    border: thin solid #3d5789 !important;
}
.categorybaseproducts-sortby-button:hover .v-input__control .v-input__slot,
.categorybaseproducts-filter-button:hover .v-input__control .v-input__slot {
    border: thin solid #3d5789 !important;
}
.categorybaseproducts-sortby-button.v-input--is-label-active.v-input--is-focused,
.categorybaseproducts-filter-button.v-input--is-label-active.v-input--is-focused
    .v-input__control
    .v-input__slot {
    border: thin solid #3d5789 !important;
}
.categorybaseproducts-sortby-button:hover .v-select__selection.v-select__selection--comma,
.categorybaseproducts-filter-button:hover .v-select__selection.v-select__selection--comma {
    color: #3d5789 !important;
}
.categorybaseproducts-sortby-button:hover .v-input__append-inner .v-input__icon .v-icon,
.categorybaseproducts-filter-button:hover .v-input__append-inner .v-input__icon .v-icon {
    color: #3d5789 !important;
}
.categorybaseproducts-sortby-button .v-field__append-inner .v-icon,
.categorybaseproducts-filter-button .v-field__append-inner .v-icon,
.categorybaseproducts-filter-button .v-field__append-inner .v-icon,
.categorybaseproducts-filter-button .v-field__field {
    color: #3d5789 !important;
}
.categorybaseproducts-sortby-button.v-input--is-label-active.v-input--is-focused
    .v-select__selection.v-select__selection--comma,
.categorybaseproducts-filter-button.v-input--is-label-active.v-input--is-focused
    .v-select__selection.v-select__selection--comma {
    color: #3d5789 !important;
}
.categorybaseproducts-sortby-button.v-input--is-label-active.v-input--is-focused.v-text-field.v-text-field--solo
    .v-input__append-inner,
.v-text-field.v-text-field--solo .v-input__prepend-inner {
    -ms-flex-item-align: center;
    align-self: center;
    padding-top: 5px;
    border-left: 1px solid #3d5789;
    padding-left: 10px;
    height: 34px;
}
.categorybaseproducts-sortby-button.v-select--active-menu .v-input__control .v-field__append-inner {
    -ms-flex-item-align: center;
    align-self: center;
    padding-top: 5px;
    border-left: 1px solid #3d5789;
    padding-left: 10px;
    height: 34px;
}
.categorybaseproducts-sortby-button.v-select--active-menu .mdi-plus::before {
    content: '\F0374' !important;
}
.searchproducts-cancel-buttons.v-icon.v-icon::after {
    opacity: 0 !important;
}
.categorybaseproducts-sortby-button .v-text-field__details {
    display: none;
}
.categorybaseproducts-sortby-button-mobile.v-input--density-compact {
    --v-input-control-height: 40px;
    --v-input-padding-top: 11px;
}
.categorybaseproducts-overflow-button .v-text-field__details {
    display: none;
}
.categorybaseproducts-filter-button .v-text-field__details {
    display: none;
}
.categorybaseproducts-overflow-button .v-input__details {
    display: none;
}
.filter-component-width .v-expansion-panels {
    display: inline-block;
}
.categorybaseproducts-pagination-button.v-pagination__item.v-pagination__item--is-active.v-btn {
    background-color: #3d5789;
}
.categorybaseproducts-pagination-button .v-btn__content {
    font-size: 16px;
    font-weight: 400;
}
.search-product-circle-border,
.search-color-circle-border {
    border: 2px solid #3d5789 !important;
}

.search-product-color-circle {
    height: 25px;
    width: 25px;
    border-radius: 50%;
    border: 1px solid #777;
}
.search-color-circle {
    height: 30px;
    width: 30px;
    border-radius: 50%;
    border: 1px solid #fff;
}

.product-image-wrapper {
    position: relative;
    padding-top: 100%; /* 1:1 square — perfect */
    background: #f8f8f8;
    overflow: hidden;
}

.skeleton-placeholder {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #eeeeee; /* bilkul Crane wala light gray */
    /* agar thoda shimmer chahiye to yeh add kar do (optional) */
    background-image: linear-gradient(90deg, #eeeeee 0%, #f5f5f5 50%, #eeeeee 100%);
    background-size: 200% 100%;
    animation: softShimmer 2s infinite;
}

@keyframes softShimmer {
    0% {
        background-position: 200% 0;
    }
    100% {
        background-position: -200% 0;
    }
}

.product-image-wrapper picture {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
}

.product-image-wrapper img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    background: white;
}
</style>
<style src="./SearchProducts.scss" lang="scss" scoped />
